<template>
<div class="chapter">
<div class="inner_page">
<div class="img_container"><a id="page_4"></a><img alt="Image" src="images/pg4.jpg"/></div>
<blockquote class="Caption">FMLN combatant, Museum of the Revolution, Perquín, El Salvador. (Photo Linda Hess Miller)</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_frontspice.vue?00d65c1e